export default "__VITE_ASSET__BYULnrZj__"